import React from 'react';
import classNames from 'classnames';

// Utils
import { SCHEMA_TYPE_MULTI_ENUM, SCHEMA_TYPE_TEXT, SCHEMA_TYPE_YOUTUBE } from '../../util/types';
import {
  isFieldForCategory,
  pickCategoryFields,
  pickCustomFieldProps,
} from '../../util/fieldHelpers.js';

import SectionDetailsMaybe from './SectionDetailsMaybe';
import SectionMultiEnumMaybe from './SectionMultiEnumMaybe';
import SectionTextMaybe from './SectionTextMaybe';
import SectionYoutubeVideoMaybe from './SectionYoutubeVideoMaybe';
// import SectionPetPricing from './SectionPetPricing';
import css from './ListingPage.module.css';

/**
 * Renders custom listing fields.
 * - SectionDetailsMaybe is used if schemaType is 'enum', 'long', or 'boolean'
 * - SectionMultiEnumMaybe is used if schemaType is 'multi-enum'
 * - SectionTextMaybe is used if schemaType is 'text'
 *
 * @param {*} props include publicData, metadata, listingFieldConfigs, categoryConfiguration
 * @returns React.Fragment containing aforementioned components
 */
const CustomListingFields = props => {
  const { publicData, metadata, listingFieldConfigs, categoryConfiguration, intl } = props;

  const { key: categoryPrefix, categories: listingCategoriesConfig } = categoryConfiguration;
  const categoriesObj = pickCategoryFields(publicData, categoryPrefix, 1, listingCategoriesConfig);
  const currentCategories = Object.values(categoriesObj);

  const isFieldForSelectedCategories = fieldConfig => {
    const isTargetCategory = isFieldForCategory(currentCategories, fieldConfig);
    return isTargetCategory;
  };
  const propsForCustomFields =
    pickCustomFieldProps(
      publicData,
      metadata,
      listingFieldConfigs,
      'listingType',
      isFieldForSelectedCategories
    ) || [];

  const videoField = propsForCustomFields.find(fi => fi.key === 'video');

  return (
    <>
      <SectionDetailsMaybe {...props} isFieldForCategory={isFieldForSelectedCategories} />

      <div className={css.detailsAndPricingContainer}>
        <div className={css.customFieldsContainer}>
          {propsForCustomFields.filter((fi) => {
            const { key } = fi;
            return !['certifications', 'behavior_experience', 'medical_experience', 'video'].includes(key);
          }).map(customFieldProps => {
            const { schemaType, key, ...fieldProps } = customFieldProps;
            const sectionClassname = key === 'sittingtypes' ? css.smallCustomListingFieldSection : css.customListingFieldSection;
            return schemaType === SCHEMA_TYPE_MULTI_ENUM ? (
              <SectionMultiEnumMaybe key={key} containerClassName={sectionClassname} {...fieldProps} />
            ) : schemaType === SCHEMA_TYPE_TEXT ? (
              <SectionTextMaybe key={key} containerClassName={sectionClassname} {...fieldProps} />
            ) : schemaType === SCHEMA_TYPE_YOUTUBE ? (
              <SectionYoutubeVideoMaybe key={key} containerClassName={sectionClassname} {...fieldProps} />
            ) : null;
          })}
        </div>
      </div>
      {
        videoField ? (
          <SectionYoutubeVideoMaybe key={videoField.key} {...videoField} />
        ) : null
      }
    </>
  );
};

export default CustomListingFields;
